import React, { useState, useContext } from 'react';
import { func, array } from 'prop-types';
import { applyFilter } from '../../../filter_tile/utils';
import { CarouselContext } from '../../../../top_filters_carousel';
import { AppContext } from '../../../../../context/listingsContext';
import Header from '../shared/header';
import Footer from '../shared/footer';
import List from '../shared/list';

const FilterListModal = ({ close, items }) => {
    const [selected, setSelected] = useState([]);
    const { filterId, subCategoryId, allFilters, setCollapseCarousel, isLastStep, setStepIndex, stepIndex, stepNum } = useContext(CarouselContext);
    const { dispatch, filter: { active: activeFilters, selected: selectedFilters } } = useContext(AppContext);
    const titleKey =`search_perseus.filter_tiles.${subCategoryId}.${filterId}`;

    const onSelect = (item, checked) => {
        const newSelected = checked ? [...selected, item.id] : selected.filter((value) => value !== item.id);
        setSelected(newSelected);
    };

    const onApply = () => {
        !isLastStep && setStepIndex(stepIndex + 1);

        applyFilter({
            filterId,
            value: selected,
            selectedFilters,
            activeFilters,
            dispatch,
            allFilters,
            setCollapseCarousel,
            stepNum,
            isLastStep });

        close();
    };

    const onClear = () => {
        setSelected([]);
    };

    return (
        <>
            <Header close={close} titleKey={titleKey}/>
            <List items={items} selected={selected} onSelect={onSelect} isMulti/>
            <Footer onApply={onApply} onClear={onClear}/>
        </>
    );
};

FilterListModal.propTypes = {
    close: func,
    items: array
};

export default FilterListModal;
